import React, { useState, useEffect } from "react";
import axiosClient from "../../../../api-client/AxiosClient";
import { toast } from "react-toastify";
import Select, { components } from "react-select";

// Custom Option component with checkbox
const Option = (props) => {
  const selectedValues = props.selectProps.value || [];
  const isSelected = Array.isArray(selectedValues)
    ? selectedValues.some((item) => item.value === props.value)
    : props.isSelected;

  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          style={{
            width: "16px",
            height: "16px",
            cursor: "pointer",
            flexShrink: 0,
          }}
        />
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {props.label}
        </span>
      </div>
    </components.Option>
  );
};


// const ValueContainer = ({ children, ...props }) => {
//   return (
//     <components.ValueContainer {...props}>
//       {props.selectProps.placeholder}
//     </components.ValueContainer>
//   );
// };
// Custom MenuList component with Select All option
const MenuList = (props) => {
  const { options, getValue, setValue, selectProps } = props;
  const selectedValues = getValue();
  const allSelected = selectedValues.length === options.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setValue([], 'clear');
    } else {
      setValue(options, 'set-value');
    }
  };

  return (
    <components.MenuList {...props}>
      <div
        onClick={handleSelectAll}
        style={{
          padding: "10px 12px",
          cursor: "pointer",
          borderBottom: "1px solid #e5e7eb",
          backgroundColor: "#f9fafb",
          fontWeight: "600",
          color: "#1e40af",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#eff6ff";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#f9fafb";
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            type="checkbox"
            checked={allSelected}
            readOnly
            style={{
              width: "16px",
              height: "16px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <span>Select All</span>
        </div>
      </div>
      {props.children}
    </components.MenuList>
  );
};

// Professional Modal Component
const UserModal = ({ show, title, onClose, children }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "600px",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: "24px 32px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "28px",
              cursor: "pointer",
              color: "#6b7280",
              lineHeight: 1,
              padding: 0,
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              transition: "all 0.2s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#f3f4f6")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            ×
          </button>
        </div>

        {/* Modal Body */}
        <div
          style={{
padding: "20px 24px",
            overflowY: "auto",
            flex: 1,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default function UserManagement() {
  const { UserMgmt } = JSON.parse(
    sessionStorage.getItem("rolesAndPermission") || "{}"
  );

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [sortAsc, setSortAsc] = useState(true);
  const [page, setPage] = useState(1);
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [allObjects, setAllObjects] = useState([]);
  const [objectsLoading, setObjectsLoading] = useState(false);
  const pageSize = 5;

  const [addForm, setAddForm] = useState({
    email: "",
    firstName: "",
    lastName: "",
    role: "",
    organisation: "",
    isActive: "true",
  });

  const [editUserId, setEditUserId] = useState(null);
  const [addLoading, setAddLoading] = useState(false);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);

  // Fetch functions
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axiosClient.get("/api/User/all");
      setUsers(response.data || []);
    } catch (err) {
      setError("Failed to load user data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchObjectsByCorporations = async (corporationIds) => {
    try {
      setObjectsLoading(true);
      if (!corporationIds || corporationIds.length === 0) {
        setAllObjects([]);
        setSelectedObjects([]);
        return;
      }

      const allObjectsPromises = corporationIds.map(async (corpId) => {
        try {
          const response = await axiosClient.get(
            `/api/Object/GetObjectByCorpId?CorporationId=${corpId}`
          );
          return (
            response.data?.map((obj) => ({
              value: obj.objectid,
              label: obj.description,
              name: obj.name,
              corporationId: corpId,
            })) || []
          );
        } catch (error) {
          return [];
        }
      });

      const objectsArrays = await Promise.all(allObjectsPromises);
      const allObjectsFlattened = objectsArrays.flat();
      const uniqueObjects = allObjectsFlattened.filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.value === obj.value)
      );

      setAllObjects(uniqueObjects);
    } catch (error) {
      toast.error("Failed to load objects. Please try again.");
    } finally {
      setObjectsLoading(false);
    }
  };

  const fetchOrganizations = async () => {
    const response = await axiosClient.get(
      "/api/corporation/GetUserCorporations"
    );
    const options = response.data?.map((item) => ({
      value: item.corporationId,
      label: item.name,
    }));
    setAllOrganizations(options || []);
  };

  const fetchRoles = async () => {
    const response = await axiosClient.get("/api/User/Roles");
    setRoles(response.data || []);
  };

  useEffect(() => {
    fetchUsers();
    fetchRoles();
    fetchOrganizations();
  }, []);

  useEffect(() => {
    if (selectedOrganizations && selectedOrganizations.length > 0) {
      const corporationIds = selectedOrganizations.map((org) => org.value);
      fetchObjectsByCorporations(corporationIds);
    } else {
      setAllObjects([]);
      setSelectedObjects([]);
    }
  }, [selectedOrganizations]);

  // Filter and sort users
  const filteredUsers = users.filter((u) =>
    `${u.first_name || ""} ${u.last_name || ""}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const nameA = `${a.first_name || ""} ${a.last_name || ""}`.toLowerCase();
    const nameB = `${b.first_name || ""} ${b.last_name || ""}`.toLowerCase();
    if (nameA < nameB) return sortAsc ? -1 : 1;
    if (nameA > nameB) return sortAsc ? 1 : -1;
    return 0;
  });

  const totalPages = Math.ceil(sortedUsers.length / pageSize);
  const pagedUsers = sortedUsers.slice((page - 1) * pageSize, page * pageSize);

  // Handlers
  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleDeleteUser = async () => {
    try {
      await axiosClient.delete(`/api/User/${editUserId}`);
      setShowDeleteModal(false);
      toast.success("User deleted successfully.");
      fetchUsers();
    } catch (err) {
      toast.error(
        "Something went wrong while deleting user. Please try again later!"
      );
    }
  };

  const handleUnlockUser = async (userToUnlock) => {
    try {
      await axiosClient.put(`/api/User/Unlock/${userToUnlock}`);
      toast.success("User unlocked successfully.");
      fetchUsers();
    } catch (err) {
      toast.error(
        "Something went wrong while unlocking user. Please try again later!"
      );
    }
  };

  const handleSubmit = async () => {
    setAddLoading(true);
    const orgValuesString = selectedOrganizations
      ?.map((item) => item.value)
      .join(", ");

    try {
      const payload = {
        email: addForm.email,
        password: "",
        firstName: addForm.firstName,
        lastName: addForm.lastName,
        role: addForm.role,
        organisation: orgValuesString,
        objects: selectedObjects?.map((item) => item.value).join(", "),
        isActive: addForm.isActive === "true",
      };

      if (editUserId) {
        await axiosClient.put(`/api/User/${editUserId}`, payload);
        toast.success("User updated successfully.");
      } else {
        await axiosClient.post("/api/User", payload);
        toast.success("User created successfully.");
      }

      setShowAdd(false);
      setAddForm({
        email: "",
        firstName: "",
        lastName: "",
        role: "",
        organisation: "",
        isActive: "true",
      });
      setSelectedOrganizations([]);
      setSelectedObjects([]);
      setEditUserId(null);
      fetchUsers();
    } catch (err) {
      toast.error("Failed to save user. Please check the details.");
    } finally {
      setAddLoading(false);
    }
  };
// Custom ValueContainer to show only 4 items
  const ValueContainer = ({ children, ...props }) => {
    const selectedValues = props.getValue();
    const MAX_VISIBLE = 4;
    
    if (!selectedValues || selectedValues.length === 0) {
      return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
    }
    
    const visibleValues = selectedValues.slice(0, MAX_VISIBLE);
    const hiddenCount = selectedValues.length - MAX_VISIBLE;
    
    return (
      <components.ValueContainer {...props}>
        {React.Children.toArray(children).map((child, index) => {
          if (child?.type === components.MultiValue) {
            const valueIndex = selectedValues.findIndex(
              (v) => v.value === child.props.data.value
            );
            if (valueIndex >= MAX_VISIBLE) {
              return null;
            }
          }
          return child;
        })}
        {hiddenCount > 0 && (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "3px 8px",
              backgroundColor: "#f3f4f6",
              borderRadius: "6px",
              fontSize: "13px",
              color: "#6b7280",
              fontWeight: "600",
              marginLeft: "4px",
            }}
          >
            +{hiddenCount} more
          </div>
        )}
      </components.ValueContainer>
    );
  };

  // Professional Select Styles
  const selectStyles = {
    container: (base) => ({ ...base, width: "100%" }),
    control: (base, state) => ({
      ...base,
      minHeight: "44px",
      borderRadius: "8px",
      borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(59, 130, 246, 0.1)" : "none",
      "&:hover": { borderColor: "#3b82f6" },
      backgroundColor: state.isDisabled ? "#f9fafb" : "white",
      cursor: state.isDisabled ? "not-allowed" : "default",
      outline: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      "input:focus": {
        boxShadow: "none",
        outline: "none",
      },
    }),
    menu: (base) => ({ ...base, zIndex: 10001 }),
    menuList: (base) => ({ ...base, maxHeight: "200px" }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#eff6ff" : "white",
      color: state.isSelected ? "#1e40af" : "#1f2937",
      cursor: "pointer",
      padding: "10px 12px",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#dbeafe",
      borderRadius: "6px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#1e40af",
      padding: "3px 6px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#1e40af",
      ":hover": { backgroundColor: "#bfdbfe", color: "#1e3a8a" },
    }),
  };
const fieldStyle = {
  marginBottom: "16px",
};

  const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "600",
  color: "#374151",
  marginBottom: "6px",
};

  const inputStyle = {
    width: "100%",
    padding: "11px 14px",
    fontSize: "14px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
  };

  const inputFocusStyle = {
    borderColor: "#3b82f6",
    boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
  };

  return (
    <div
      style={{
        borderRadius: "16px",
        backgroundColor: "white",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "24px",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "700",
          marginBottom: "8px",
          color: "#111827",
        }}
      >
        User Management
      </h2>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <input
            type="text"
            placeholder="Search by name..."
            value={search}
            onChange={handleSearch}
            style={{
              ...inputStyle,
              width: "300px",
              minWidth: "250px",
            }}
            onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
            onBlur={(e) => {
              e.target.style.borderColor = "#d1d5db";
              e.target.style.boxShadow = "none";
            }}
          />
          {UserMgmt?.canAdd && (
            <button
              onClick={() => {
                setShowAdd(true);
                setEditUserId(null);
                setAddForm({
                  email: "",
                  firstName: "",
                  lastName: "",
                  role: "",
                  organisation: "",
                  isActive: "true",
                });
                setSelectedOrganizations([]);
                setSelectedObjects([]);
                
              }}
              style={{
                backgroundColor: "#1e40af",
                color: "white",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#1e3a8a")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#1e40af")
              }
            >
              <span style={{ fontSize: "20px", fontWeight: "700" }}>+</span> Add
              User
            </button>
          )}
        </div>
      </div>

      {/* Add/Edit User Modal */}
      <UserModal
        show={showAdd}
        title={editUserId ? "Edit User" : "Add User"}
        onClose={() => setShowAdd(false)}
      >
        <div>
          {/* Email */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Email <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="email"
              placeholder="Enter email address"
              value={addForm.email}
              onChange={(e) =>
                setAddForm((f) => ({ ...f, email: e.target.value }))
              }
              disabled={editUserId !== null}
              style={{
                ...inputStyle,
                backgroundColor: editUserId !== null ? "#f9fafb" : "white",
                cursor: editUserId !== null ? "not-allowed" : "text",
              }}
              onFocus={(e) =>
                !editUserId && Object.assign(e.target.style, inputFocusStyle)
              }
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          {/* First Name */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              First Name <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter first name"
              value={addForm.firstName}
              onChange={(e) =>
                setAddForm((f) => ({ ...f, firstName: e.target.value }))
              }
              style={inputStyle}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          {/* Last Name */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Last Name <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter last name"
              value={addForm.lastName}
              onChange={(e) =>
                setAddForm((f) => ({ ...f, lastName: e.target.value }))
              }
              style={inputStyle}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          {/* Role */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Role <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <select
              value={addForm.role}
              onChange={(e) =>
                setAddForm((f) => ({ ...f, role: e.target.value }))
              }
              style={{
                ...inputStyle,
                cursor: "pointer",
              }}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            >
              <option value="" disabled>
                Select Role
              </option>
              {roles?.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>

          {/* Organisation */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Organisation <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <Select
              options={allOrganizations}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option }}
              onChange={(selected) => setSelectedOrganizations(selected)}
              value={selectedOrganizations}
              placeholder="Select organisations"
              styles={selectStyles}
              menuIsOpen={undefined}        
             openMenuOnClick={true}         
             isClearable={false}
            />
          </div>

          {/* Objects */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Objects <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <Select
              options={allObjects}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option,MenuList,ValueContainer }}
              onChange={(selected) => setSelectedObjects(selected)}
              value={selectedObjects}
              placeholder={
                objectsLoading ? "Loading objects..." : "Select objects"
              }
              isDisabled={objectsLoading || allObjects.length === 0}
              styles={selectStyles}
              menuIsOpen={undefined}        // ADD THIS LINE
  openMenuOnClick={true}         // ADD THIS LINE
  isClearable={false} 
            />
            {selectedOrganizations.length === 0 && (
              <small
                style={{
                  display: "block",
                  marginTop: "6px",
                  color: "#6b7280",
                  fontSize: "13px",
                }}
              >
                Please select at least one organisation first
              </small>
            )}
          </div>

          {/* Status */}
          <div style={fieldStyle}>
            <label style={labelStyle}>
              Status <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <select
              value={addForm.isActive}
              onChange={(e) =>
                setAddForm((f) => ({ ...f, isActive: e.target.value }))
              }
              style={{
                ...inputStyle,
                cursor: "pointer",
              }}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-end",
              marginTop: "32px",
            }}
          >
            <button
              onClick={() => setShowAdd(false)}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "white",
                color: "#374151",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#f9fafb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "white")
              }
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={addLoading}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: addLoading ? "#9ca3af" : "#f97316",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                cursor: addLoading ? "not-allowed" : "pointer",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) =>
                !addLoading &&
                (e.currentTarget.style.backgroundColor = "#ea580c")
              }
              onMouseOut={(e) =>
                !addLoading &&
                (e.currentTarget.style.backgroundColor = "#f97316")
              }
            >
              {addLoading ? "Saving..." : "Save User"}
            </button>
          </div>
        </div>
      </UserModal>

      {/* Delete Confirmation Modal */}
      <UserModal
        show={showDeleteModal}
        title="Delete User"
        onClose={() => setShowDeleteModal(false)}
      >
        <div>
          <p
            style={{ fontSize: "16px", color: "#6b7280", marginBottom: "24px" }}
          >
            Are you sure you want to delete this user?
          </p>
          <div
            style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}
          >
            <button
              onClick={() => setShowDeleteModal(false)}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "white",
                color: "#374151",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#f9fafb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "white")
              }
            >
              Cancel
            </button>
            <button
              onClick={handleDeleteUser}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#ef4444",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#dc2626")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#ef4444")
              }
            >
              Delete
            </button>
          </div>
        </div>
      </UserModal>

      {/* Users Table */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "48px", color: "#6b7280" }}>
          Loading users...
        </div>
      ) : error ? (
        <div style={{ textAlign: "center", padding: "48px", color: "#ef4444" }}>
          {error}
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <thead>
              <tr
                style={{
                  background: "linear-gradient(to right, #eff6ff, #dbeafe)",
                }}
              >
                <th
                  onClick={() => setSortAsc(!sortAsc)}
                  style={{
                    padding: "16px 20px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    cursor: "pointer",
                    borderBottom: "2px solid #bfdbfe",
                  }}
                >
                  Name{" "}
                  <span style={{ marginLeft: "8px", fontSize: "12px" }}>
                    {sortAsc ? "▲" : "▼"}
                  </span>
                </th>
                <th
                  style={{
                    padding: "16px 20px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    borderBottom: "2px solid #bfdbfe",
                  }}
                >
                  Email
                </th>
                <th
                  style={{
                    padding: "16px 20px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    borderBottom: "2px solid #bfdbfe",
                  }}
                >
                  Role
                </th>
                <th
                  style={{
                    padding: "16px 20px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    borderBottom: "2px solid #bfdbfe",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    padding: "16px 20px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    borderBottom: "2px solid #bfdbfe",
                  }}
                >
                  Created Date
                </th>
                {(UserMgmt?.canDelete || UserMgmt?.canUpdate) && (
                  <th
                    style={{
                      padding: "16px 20px",
                      textAlign: "left",
                      fontWeight: "700",
                      color: "#374151",
                      borderBottom: "2px solid #bfdbfe",
                    }}
                  >
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {pagedUsers.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      padding: "48px",
                      textAlign: "center",
                      color: "#9ca3af",
                    }}
                  >
                    No users found.
                  </td>
                </tr>
              ) : (
                pagedUsers.map((user, idx) => (
                  <tr
                    key={user.id}
                    style={{
                      backgroundColor: idx % 2 === 0 ? "white" : "#f9fafb",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#eff6ff")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        idx % 2 === 0 ? "white" : "#f9fafb")
                    }
                  >
                    <td
                      style={{
                        padding: "16px 20px",
                        color: "#111827",
                        fontWeight: "500",
                        borderBottom:
                          idx === pagedUsers.length - 1
                            ? "none"
                            : "1px solid #e5e7eb",
                      }}
                    >
                      {`${user.first_name || ""} ${
                        user.last_name || ""
                      }`.trim()}
                    </td>
                    <td
                      style={{
                        padding: "16px 20px",
                        color: "#6b7280",
                        borderBottom:
                          idx === pagedUsers.length - 1
                            ? "none"
                            : "1px solid #e5e7eb",
                      }}
                    >
                      {user.email}
                    </td>
                    <td
                      style={{
                        padding: "16px 20px",
                        borderBottom:
                          idx === pagedUsers.length - 1
                            ? "none"
                            : "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor: "#dbeafe",
                          color: "#1e40af",
                          border: "1px solid #bfdbfe",
                        }}
                      >
                        {user.role}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "16px 20px",
                        borderBottom:
                          idx === pagedUsers.length - 1
                            ? "none"
                            : "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor: user.isactive
                            ? "#dcfce7"
                            : "#fee2e2",
                          color: user.isactive ? "#16a34a" : "#dc2626",
                          border: `1px solid ${
                            user.isactive ? "#bbf7d0" : "#fecaca"
                          }`,
                        }}
                      >
                        {user.isactive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "16px 20px",
                        color: "#6b7280",
                        borderBottom:
                          idx === pagedUsers.length - 1
                            ? "none"
                            : "1px solid #e5e7eb",
                      }}
                    >
                      {user.created_at}
                    </td>
                    {(UserMgmt?.canDelete || UserMgmt?.canUpdate) && (
                      <td
                        style={{
                          padding: "16px 20px",
                          borderBottom:
                            idx === pagedUsers.length - 1
                              ? "none"
                              : "1px solid #e5e7eb",
                        }}
                      >
                        <div style={{ display: "flex", gap: "8px" }}>
                          {UserMgmt?.canUpdate && (
                            <button
                              onClick={() => {
                                const selectedUserRole = roles.find(
                                  (role) =>
                                    role.name.toLowerCase() ===
                                    user.role.toLowerCase()
                                )?.id;

                                setShowAdd(true);
                                setEditUserId(user.id);
                                setAddForm({
                                  email: user.email || "",
                                  firstName: user.first_name || "",
                                  lastName: user.last_name || "",
                                  role: selectedUserRole || "",
                                  organisation: user.organisation || "",
                                  isActive: user.isactive.toString(),
                                });
                                setSelectedOrganizations(user.orgList || []);
                                setSelectedObjects(user.objList || []);
                              }}
                              style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #3b82f6",
                                backgroundColor: "#eff6ff",
                                color: "#1e40af",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "600",
                                transition: "all 0.2s",
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#dbeafe";
                                e.currentTarget.style.borderColor = "#2563eb";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#eff6ff";
                                e.currentTarget.style.borderColor = "#3b82f6";
                              }}
                              title="Edit user"
                            >
                              ✏️ Edit
                            </button>
                          )}

                          {!user.accountenabled && (
                            <button
                              onClick={() => handleUnlockUser(user.id)}
                              style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #10b981",
                                backgroundColor: "#f0fdf4",
                                color: "#059669",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "600",
                                transition: "all 0.2s",
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#dcfce7";
                                e.currentTarget.style.borderColor = "#059669";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#f0fdf4";
                                e.currentTarget.style.borderColor = "#10b981";
                              }}
                              title="Unlock user"
                            >
                              🔓 Unlock
                            </button>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={UserMgmt?.canDelete || UserMgmt?.canUpdate ? 6 : 5}
                  style={{
                    padding: "16px 20px",
                    textAlign: "right",
                    fontSize: "12px",
                    color: "#6b7280",
                    backgroundColor: "#f9fafb",
                    borderTop: "1px solid #e5e7eb",
                  }}
                >
                  Showing {pagedUsers.length} of {sortedUsers.length} user
                  {sortedUsers.length !== 1 ? "s" : ""}
                </td>
              </tr>
              {totalPages > 1 && (
                <tr>
                  <td
                    colSpan={UserMgmt?.canDelete || UserMgmt?.canUpdate ? 6 : 5}
                    style={{
                      padding: "16px 20px",
                      backgroundColor: "white",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <button
                        onClick={() => setPage(page - 1)}
                        disabled={page === 1}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          backgroundColor: page === 1 ? "#f3f4f6" : "white",
                          color: page === 1 ? "#9ca3af" : "#374151",
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          fontSize: "14px",
                          fontWeight: "600",
                          transition: "all 0.2s",
                        }}
                        onMouseOver={(e) => {
                          if (page !== 1) {
                            e.currentTarget.style.backgroundColor = "#eff6ff";
                            e.currentTarget.style.borderColor = "#3b82f6";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (page !== 1) {
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.borderColor = "#d1d5db";
                          }
                        }}
                      >
                        Prev
                      </button>

                      {[...Array(totalPages)].map((_, i) => (
                        <button
                          key={i}
                          onClick={() => setPage(i + 1)}
                          style={{
                            padding: "8px 16px",
                            borderRadius: "6px",
                            border: `1px solid ${
                              page === i + 1 ? "#1e40af" : "#d1d5db"
                            }`,
                            backgroundColor:
                              page === i + 1 ? "#1e40af" : "white",
                            color: page === i + 1 ? "white" : "#374151",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            minWidth: "40px",
                            transition: "all 0.2s",
                          }}
                          onMouseOver={(e) => {
                            if (page !== i + 1) {
                              e.currentTarget.style.backgroundColor = "#eff6ff";
                              e.currentTarget.style.borderColor = "#3b82f6";
                            }
                          }}
                          onMouseOut={(e) => {
                            if (page !== i + 1) {
                              e.currentTarget.style.backgroundColor = "white";
                              e.currentTarget.style.borderColor = "#d1d5db";
                            }
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        onClick={() => setPage(page + 1)}
                        disabled={page === totalPages}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          backgroundColor:
                            page === totalPages ? "#f3f4f6" : "white",
                          color: page === totalPages ? "#9ca3af" : "#374151",
                          cursor:
                            page === totalPages ? "not-allowed" : "pointer",
                          fontSize: "14px",
                          fontWeight: "600",
                          transition: "all 0.2s",
                        }}
                        onMouseOver={(e) => {
                          if (page !== totalPages) {
                            e.currentTarget.style.backgroundColor = "#eff6ff";
                            e.currentTarget.style.borderColor = "#3b82f6";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (page !== totalPages) {
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.borderColor = "#d1d5db";
                          }
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
